module.exports = __webpack_public_path__ + "img/clayster.279010ea.png";